import { put, call, take, fork } from 'redux-saga/effects'
import { collectionShowcaseService } from 'src/api/collection'
import { collectionShowcaseSuccess } from 'src/reducers/collection/action'
import { COLLECTION_SHOWCASE } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* collectionShowcaseFlow(payload) {
  try {
    const { data, callback } = payload
    const response = yield call(collectionShowcaseService, data)

    yield put(collectionShowcaseSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* collectionShowcaseWatcher() {
  while (true) {
    const action = yield take(COLLECTION_SHOWCASE)
    const { payload } = action

    yield fork(generalSaga, collectionShowcaseFlow, payload)
  }
}
